import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-chevron-up-icon',
  templateUrl: 'chevron-up-icon.component.html'
})
export class ChevronUpIconComponent {
  constructor() {}
}
